/** Staff employee ID + access request API (signup on Team, approve on Manage Team page). */

import { uploadFormWithRetry } from "@/lib/driverImageUpload";

function parseApiError(data, fallback) {
  const detail = data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d?.msg || d?.loc?.join(".") || JSON.stringify(d)).join("; ");
  }
  return fallback;
}

export function isTsNeedsSignupError(message) {
  return String(message || "").includes("needs_signup");
}

export async function registerTsEmployee({
  name,
  phone,
  address,
  upiId,
  photoFile,
  aadharFile,
  firebaseIdToken,
}) {
  const fd = new FormData();
  fd.append("name", name);
  fd.append("phone", phone);
  fd.append("address", address);
  // Legacy column still required by API/DB — staff signup no longer collects scooter/license.
  fd.append("scooter_number", "");
  fd.append("upi_id", upiId);
  fd.append("firebase_id_token", firebaseIdToken);
  fd.append("photo", photoFile, "profile.webp");
  fd.append("aadhar_photo", aadharFile, "aadhar.webp");
  // uploadFormWithRetry throws on non-OK; body is pending employee + status.
  const res = await uploadFormWithRetry("/api/ts/employee/register", fd);
  return res.json();
}

export async function loginTsFirebaseWithStatus(firebaseIdToken) {
  const fd = new FormData();
  fd.append("firebase_id_token", firebaseIdToken);
  const res = await fetch("/api/ts/login-firebase", { method: "POST", body: fd });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = parseApiError(data, "Could not log in");
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return data;
}
